// extracted by mini-css-extract-plugin
module.exports = {"dream_post_menu":"DreamPostMenu_dream_post_menu_11DG1","top":"DreamPostMenu_top_P1AWB"};